/**
 * Item price types for storage and team plans
 */
export enum ItemPriceType {
  Original = 1,
  First = 2,
  Renew = 3,
  Upgrade = 4,
  Student = 5,
}
